import React from 'react';
import { LoanField } from '../types/loan';
import { FieldRow } from './FieldRow';
interface FieldGridProps {
  fields: LoanField[];
  columns?: 1 | 2;
  onChange: (id: string, value: string) => void;
}
export function FieldGrid({
  fields,
  columns = 1,
  onChange
}: FieldGridProps) {
  if (columns === 1) {
    return <div className="border-t border-slate-200" data-id="element-67" data-mp="39pa1e74kttma">
        {fields.map(field => <FieldRow key={field.id} field={field} onChange={onChange} data-id="element-68" data-mp="34ri7x8oa9zfz" />)}
      </div>;
  }
  return <div className="grid grid-cols-1 border-t border-slate-200 md:grid-cols-2 md:gap-x-8" data-id="element-69" data-mp="2zzgxztel8kt4">
      {fields.map(field => <FieldRow key={field.id} field={field} onChange={onChange} data-id="element-70" data-mp="2vz6jttgn6o36" />)}
    </div>;
}